import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { TranslationService } from '@core/services/translation.service';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable, switchMap } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class AppComponent {
  private oidcSecurityService = inject(OidcSecurityService);
  private translation = inject(TranslationService);

  loadingTranslations$: Observable<boolean>;
  constructor() {
    this.authenticate();
    this.loadingTranslations$ = this.translation.loadingTranslations$;
  }

  private authenticate(): void {
    this.oidcSecurityService
      .getState()
      .pipe(
        switchMap(state => {
          if (!state) {
            const urlState = decodeURIComponent(window.location.href)
              .split('&')
              .find(val => val.includes('state='))
              ?.replace('state=', '');

            if (urlState) {
              window.location.href = '/';
            }
          }
          return this.oidcSecurityService.checkAuth();
        })
      )
      .subscribe();
  }
}
